import http from '../../services/http-common';
import securityService from '../../components/security/security.service';


class TenantContractPMService {
  getPropertyDetailForList(id) {
    return http.get(`/TenantContractPM/PropertyDetailForList/${id}`);
  }
  getPaymentDetailForList(id, IsChequeCleared) {
    return http.get(`/TenantContractPM/PaymentDetailForList/${securityService.getCompanyIDLoggedInUserId()}/${id}/2`);
  }
  getAdditionalPaymentDetailForList(id) {
    return http.get(`/TenantContractPM/AdditionalPaymentDetailForList/${id}`);
  }
  getAmountForAddionalPaymentForPercent(val1, val2) {
    let queryParams = new URLSearchParams({ContractAmountAED:val1,Percent:val2}).toString();

    return http.get(`/TenantContractPM/GetAmountForAddionalPaymentForPercent?${queryParams}`);
  }
  getAgentCommissionAmount(val1, val2,val3) {
    let queryParams = new URLSearchParams({ChequeAmount:val1,AdditionalPaymentAmount:val2,AgentCommissionPercent:val3}).toString();

    return http.get(`/TenantContractPM/GetAgentCommissionAmount?${queryParams}`);
  }

  getTenantContractPMAmount(val1, val2,val3,val4) {
    let queryParams = new URLSearchParams({RentAmountAED:val1,DiscountAmountAED:val2,ContractStartDate:val3,ContractEndDate:val4}).toString();
    return http.get(`/TenantContractPM/GetTenantContractPMAmount?${queryParams}`);
  }


  updateTenantContractPMAdditionalPaymentPercentBasedCalculations(val1, val2) {
    let queryParams = new URLSearchParams({ContractAmountAED:val1,TenantContractPMID:val2}).toString();

    return http.get(`/TenantContractPM/updateTenantContractPMAdditionalPaymentPercentBasedCalculations?${queryParams}`);
  }
  getTotalTenantContractPMAmount(val1, val2,val3) {
    let queryParams = new URLSearchParams({ContractAmountAED:val1,DepositAmount:val2,GridSum:val3}).toString();

    return http.get(`/TenantContractPM/GetTotalTenantContractPMAmount?${queryParams}`);
  }
  spGetAddionalPayment() {
    return http.get(`/TenantContractPM/AddionalPayment`);
  }
  getTenantContractPMForList() {
    let queryParams = new URLSearchParams({CompanyID:securityService.getCompanyIDLoggedInUserId()}).toString();
    return http.get(`/TenantContractPM/db/table?${queryParams}`);
  }




  insertPropertyDetailWithMain(data) {
    return http.post(`/TenantContractPM/db/PropertyDetailWithMain/add`, data);
  }
  insertPropertyDetail(data) {
    return http.post(`/TenantContractPM/db/PropertyDetail/add`, data);
  }
  
  insertPaymentDetail(data) {
    return http.post(`/TenantContractPM/db/PaymentDetail/add`, data);
  }
  insertPaymentDetailWithMain(data) {
    return http.post(`/TenantContractPM/db/PaymentDetailWithMain/add`, data);
  }
  insertAdditionalPaymentDetail(data) {
    return http.post(`/TenantContractPM/db/AdditionalPaymentDetail/add`, data);
  }
  insertAdditionalPaymentDetailWithMain(data) {
    return http.post(`/TenantContractPM/db/AdditionalPaymentDetailWithMain/add`, data);
  }
  
  insertAdditionalPaymentDetailSWithMain(data) {
    return http.post(`/TenantContractPM/db/AdditionalPaymentDetailsWithMain/add`, data);
  }
  
  
  updatePropertyDetail(data) {
    return http.put(`/TenantContractPM/db/PropertyDetail/edit`, data);
  }

  updatePaymentDetail(data) {
    return http.put(`/TenantContractPM/db/PaymentDetail/edit`, data);
  }
  updateAddtionalPaymentDetail(data) {
    return http.put(`/TenantContractPM/db/AdditionalPaymentDetail/edit`, data);
  }


  insert(data) {
    return http.post(`/TenantContractPM/db/add`, data);
  }
  update(data) {
    return http.put(`/TenantContractPM/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/TenantContractPM/db/delete/${PropertyID}`);
  }
}

export default new TenantContractPMService();